export const palette = {
  blue1: '#74C5E0',
  blue2: '#0FB8DC',
  gray1: '#1B2634',
  gray2: '#0D1A2B',
  gray3: 'rgb(57, 63, 75)', // #393F4B
  gray4: 'rgb(24, 32, 46)', // #18202E
  gray5: '#e1e1e1',
  gray6: '#10171f',
  gray7: '#767D85',
  gray8: '#f1f1f1',
  gray9: '#2c3e50',
  gray10: '#353535',
  white1: '#e8e8e8',
  white2: '#AAAAAA',
  white3: '#BEBEBE',
  orange1: 'rgb(224, 151, 56)', // #E09738
  red1: 'rgb(196, 52, 52)', // #C43434
  red2: '#EA475B',
  red3: '#BD4040',
  purple1: '#3F007D',
  purple2: '#54278F',
  purple3: '#6A51A3',
  purple4: '#9E9AC8',
  green1: '#279673',

  // This begins the conversion to Muse names
  mainBackground2: '#49515D',
  dimBackground: '#10171F',
  dangerMain: '#FF7B88',
  cautionMain: '#E0B400',
  ribbonColor: '#F07377',
  borderMain: '#777777',

  // CVE
  red4: '#FF7B88',
  orange2: '#F0950E',
  yellow1: '#FFE352',
  blue3: '#99DDFF',
  blue4: '#223C4F'
}

export default palette
